import { AuthService } from './../service/auth.service';
import { Component, OnInit } from "@angular/core";
import { AbstractControl, FormControl, FormGroup, ValidationErrors, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from '@angular/router';
import {
  CAMPAIGN_LANDING_SOURCE,
  ThiCampaignAttributionService,
} from 'src/app/landing-pages/thi/campaign/thi-campaign-attribution.service';
import { ThiLandingAnalyticsService } from 'src/app/landing-pages/thi/campaign/thi-landing-analytics.service';
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from 'ngx-toastr';
import { RegisterEndPoient } from 'src/app/Data/service/global.service';
import Swal from 'sweetalert2';
import { israelPhoneNumberValidator } from './../../validators/israelPhoneNumberValidator';
import { passwordValidators } from '../../validators/passwordValidators';
import { Language } from "src/app/landing-pages/thi/thi-translations";
import { normalizeThiLang } from "src/app/landing-pages/thi/thi-lang.util";

@Component({
  selector: "app-register",
  templateUrl: "./register.component.html",
  styleUrls: ["./register.component.scss"]
})

export class RegisterComponent implements OnInit {

  public show: boolean = false;
  public showConfirm: boolean = false;
  userLanguage: string;
  RegisterForm: FormGroup;
  curentLang:string="";
  landingLang: Language = "ar";

  private pendingPlanId: string | null = null;

  constructor(
    private spinner: NgxSpinnerService,
    private authService: AuthService,
    private Router: Router,
    private ToastrService: ToastrService,
    private route: ActivatedRoute,
    private campaignAttribution: ThiCampaignAttributionService,
    private landingAnalytics: ThiLandingAnalyticsService,
  ) {
    this.userLanguage = localStorage.getItem('curentLang');
    this.RegisterForm = new FormGroup(
      {
        'phone_number': new FormControl('', [
          Validators.required,
          Validators.pattern(/^\d{10}$/),
          israelPhoneNumberValidator()
        ]),
        'first_name': new FormControl('', [Validators.required, Validators.maxLength(20)]),
        'last_name': new FormControl('', [Validators.required, Validators.maxLength(20)]),
        'user_name': new FormControl('', [Validators.maxLength(40)]),
        'language': new FormControl(this.userLanguage),
        'merchant_name_en': new FormControl(''),
        'merchant_name_ar': new FormControl(''),
        'merchant_name_he': new FormControl('', [Validators.maxLength(80)]),
        'merchant_address': new FormControl('', [Validators.required]),
        'id_number': new FormControl('', [Validators.required, Validators.pattern(/^\d{9}$/)]),
        'password': new FormControl('', passwordValidators),
        'confirm_password': new FormControl('', [Validators.required]),
        'acceptTerms': new FormControl(false, [Validators.requiredTrue]),
      },
      { validators: this.passwordsMatchValidator }
    );

    this.curentLang = localStorage.getItem('curentLang');
    this.landingLang = normalizeThiLang(this.curentLang);

  };

  submitRegisterForm(RegisterForm: FormGroup) {
    let customerPhone = this.RegisterForm.value.phone_number;
    if (customerPhone.startsWith('0')) {
      customerPhone = customerPhone.substring(1);
    }
    let password = this.RegisterForm.value.password;
      if (password.length < 8 || password.length > 20) {
          Swal.fire({
              icon: 'error',
              title: this.curentLang === 'ar' ? 'يجب أن تكون كلمة المرور أطول من أو تساوي 8 أحرف وأقل من أو تساوي 20 حرفًا' : 
                     (this.curentLang === 'en' ? 'Password must be longer than or equal to 8 characters and shorter than or equal to 20 characters' : 
                     (this.curentLang === 'he' ? 'הסיסמה חייבת להיות ארוכה מ-8 תווים וקצרה מ-20 תווים' : ''))
          });
          return;
      }

    const firstName = (this.RegisterForm.value.first_name || '').trim();
    const lastName = (this.RegisterForm.value.last_name || '').trim();
    const fullName = `${firstName} ${lastName}`.trim();

    this.RegisterForm.patchValue({
      user_name: fullName,
      merchant_name_he: fullName,
      merchant_name_ar: fullName,
      merchant_name_en: fullName
    });

    let model = {
      "phone_number": '+972' + customerPhone,
      "user_name": fullName,
      "language": this.userLanguage,
      "merchant_name_en": fullName,
      "merchant_name_ar": fullName,
      "merchant_name_he": fullName,
      "merchant_address": RegisterForm.value.merchant_address,
      "id_number": RegisterForm.value.id_number,
      "password": RegisterForm.value.password,
    };

    this.spinner.show();

    this.authService.Register(RegisterEndPoient.POST, model).subscribe({
      next: (response: any) => {
        if (response.status === 400 || response.status === 403) {
          let errorMessage = "";
          switch (this.userLanguage) {
            case "ar":
              errorMessage = response.messageAr;
              break;
            case "en":
              errorMessage = response.messageEn;
              break;
            case "he":
              errorMessage = response.messageHe;
              break;
            default:
              errorMessage = "Unknown error occurred";
          }
          Swal.fire({
            icon: 'error',
            title: errorMessage,
          });
        } else {
          let successMessage = "";
          switch (this.userLanguage) {
            case "ar":
              successMessage = response.messageAr;
              break;
            case "en":
              successMessage = response.messageEn;
              break;
            case "he":
              successMessage = response.messageHe;
              break;
            default:
              successMessage = "Unknown message";
          }
          Swal.fire({
            icon: 'success',
            title: successMessage,
          });
          if (this.isCampaignRegistration()) {
            this.landingAnalytics.registrationCompleted(this.landingLang);
          }
          this.Router.navigate(['/login']);
        }
        this.spinner.hide();
      },
      error: (error: any) => {
        Swal.fire({
          icon: 'error',
          title: error.message || 'Error',
          text: error.message_ar || error.message_en || error.error_en || error.error_ar || 'Unknown error occurred',
        });
        this.spinner.hide();
      }
    });
  };

  filterLangType(event: any) {
    let x = event.target.value;
  };

  ngOnInit() {
    this.spinner.show();

    setTimeout(() => {
      this.spinner.hide();
    }, 1000);

    this.userLanguage = localStorage.getItem('curentLang');
    this.landingLang = normalizeThiLang(this.userLanguage);

    this.route.queryParams.subscribe((params) => {
      this.campaignAttribution.captureFromRoute(params);
      const planId = params['planId'];
      if (planId != null && String(planId).trim()) {
        this.pendingPlanId = String(planId);
      }
      if (this.isCampaignRegistration()) {
        this.campaignAttribution.markRegistrationStarted();
        this.landingAnalytics.registrationStarted(this.landingLang);
      }
    });
  }

  private isCampaignRegistration(): boolean {
    const stored = this.campaignAttribution.getStored();
    if (stored?.source === CAMPAIGN_LANDING_SOURCE) {
      return true;
    }
    const src = this.route.snapshot.queryParamMap.get('source');
    return src === CAMPAIGN_LANDING_SOURCE;
  }

  showPassword() {
    this.show = !this.show;
    const passwordInput = document.querySelector('input[name="login[password]"]') as HTMLInputElement;
    if (passwordInput) {
      passwordInput.focus();
    }
    this.handlePasswordValidation(this.RegisterForm);
  }

  showConfirmPassword() {
    this.showConfirm = !this.showConfirm;
    const confirmInput = document.querySelector('input[name="login[confirm_password]"]') as HTMLInputElement;
    if (confirmInput) {
      confirmInput.focus();
    }
    this.handlePasswordValidation(this.RegisterForm);
  }

  handlePasswordValidation(formGroup: FormGroup) {
    const passwordControl = formGroup.get('password');
    if (passwordControl) {
      passwordControl.markAsTouched();
    }
  }

  get passwordChecks() {
    const pw = this.RegisterForm?.get('password')?.value || '';
    return {
      minLength:   pw.length >= 8,
      uppercase:   /[A-Z]/.test(pw),
      lowercase:   /[a-z]/.test(pw),
      number:      /[0-9]/.test(pw),
      specialChar: /[!@#$%^&*(),.?":{}|<>]/.test(pw),
    };
  }

  get passwordMismatch(): boolean {
    return !!(
      this.RegisterForm.hasError('passwordMismatch') &&
      this.RegisterForm.get('confirm_password')?.touched
    );
  }

  private passwordsMatchValidator(control: AbstractControl): ValidationErrors | null {
    const password = control.get('password')?.value;
    const confirmPassword = control.get('confirm_password')?.value;
    if (!confirmPassword) {
      return null;
    }
    return password === confirmPassword ? null : { passwordMismatch: true };
  }

  get passwordStrength() {
    const pw = this.RegisterForm?.get('password')?.value || '';
    if (!pw) {
      return { score: 0, label: '', className: '' };
    }

    const checks = this.passwordChecks;
    const score = [
      checks.minLength,
      checks.uppercase,
      checks.lowercase,
      checks.number,
      checks.specialChar
    ].filter(Boolean).length;

    if (score <= 2) {
      return {
        score,
        label: this.curentLang === 'ar' ? 'ضعيفة' : (this.curentLang === 'he' ? 'חלשה' : 'Weak'),
        className: 'weak'
      };
    }

    if (score <= 4) {
      return {
        score,
        label: this.curentLang === 'ar' ? 'متوسطة' : (this.curentLang === 'he' ? 'בינונית' : 'Medium'),
        className: 'medium'
      };
    }

    return {
      score,
      label: this.curentLang === 'ar' ? 'قوية' : (this.curentLang === 'he' ? 'חזקה' : 'Strong'),
      className: 'strong'
    };
  }
}
